import { AmountOfEmployees } from '@nemuru-eng/js-api-client';

import { Text } from '../components/shared/components/Text';

export const AmountOfEmployeesOptions = Object.values(AmountOfEmployees).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
